/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { toast } from "react-toastify";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatePrice from "./SpecialDates/DatePrice";
import moment from "moment";
import { deletes, post, put } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#F4F4F4",
    borderColor: state.isFocused ? "#333" : "#ccc",
    boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
    "&:hover": {
      borderColor: "#333",
    },
  }),
};
const SpecialDate = ({
  setTabsData,
  tabsData,
  room_id,
  property_id,
  viewOnly,
}) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [popup, setPopup] = useState(false);
  const datesScrollRef = useRef(null);
  const [dates, setDates] = useState([]);
  const [startDate, setStartDate] = useState();
  const [specialPriceData, setSpecialPriceData] = useState({});
  const [formData, setFormData] = useState({
    id: "",
    slotType: "",
    slotTime: "",
    propPrice: "",
    vowCommission: "",
    extraPrice: "",
    extraCommission: "",
    specialPrice: "",
    specialCommission: "",
    specialExtraPrice: "",
    specialExtraCommission: "",
    day: "",
  });

  const handleEdit = (data) => {
    const {
      id,
      spl_extra_person_commision,
      spl_extra_person_price,
      spl_property_price,
      spl_vow_commision,
      time_slot_id,
      property_room_price,
    } = data;
    const find_slot = specialPriceData?.[selectedDay]?.slotsList?.find(
      (s) => s.time_slot === time_slot_id
    );

    const find_slot_type = specialPriceData?.[selectedDay]?.createdslots?.find(
      (s) => s.id === time_slot_id
    );

    console.log(
      // find_slot_type,
      "time slot",
      // time_slot_id,
      data
      // specialPriceData?.[selectedDay]
    );
    setShowAdd(id);
    setFormData({
      id: id,
      slotType: {
        value: find_slot_type?.id,
        label: find_slot_type?.timeslot_name,
      },
      slotTime: {
        value: find_slot_type?.id,
        label: find_slot_type?.timeslot_type,
      },
      Slot_id: time_slot_id,
      propPrice: find_slot?.property_price,
      vowCommission: find_slot?.vow_commision,
      extraPrice: find_slot?.extra_person_price,
      extraCommission: find_slot?.extra_person_commision,
      specialPrice: spl_property_price,
      specialCommission: spl_vow_commision,
      specialExtraPrice: spl_extra_person_price,
      specialExtraCommission: spl_extra_person_commision,
      property_room_price: property_room_price,
    });
  };

  const handleSubmit = async () => {
    if (!formData.slotType) {
      toast.error("Slot Type  is required");
      return;
    }
    if (!formData.slotTime) {
      toast.error("Slot Time is required");
      return;
    }
    if (!formData.propPrice) {
      toast.error("Property Price is required");
      return;
    }
    if (!formData.vowCommission) {
      toast.error("Vow Commission is required");
      return;
    }
    // if (!formData.extraPrice) {
    //   toast.error("Extra Price  is required");
    //   return;
    // }
    // if (!formData.extraCommission) {
    //   toast.error("Extra Commission is required");
    //   return;
    // }
    if (!formData.specialPrice) {
      toast.error("Special Date Property Price  is required");
      return;
    }
    if (!formData.specialCommission) {
      toast.error("Special Date Vow Commission is required");
      return;
    }
    // if (!formData.specialExtraPrice) {
    //   toast.error("Special Property Extra Person Price  is required");
    //   return;
    // }
    // if (!formData.specialExtraCommission) {
    //   toast.error("Special Vow Extra Commission is required");
    //   return;
    // }
    const {
      id,
      specialPrice,
      specialCommission,
      specialExtraPrice,
      specialExtraCommission,
    } = formData;
    const payload = {
      special_date: moment(selectedDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
      property: property_id,
      property_room: room_id,
      property_room_price:
        showAdd === "add" ? formData?.Slot_id : formData?.property_room_price,
      spl_property_price: specialPrice,
      spl_vow_commision: specialCommission,
      spl_extra_person_price: specialExtraPrice ? specialExtraPrice : 0,
      spl_extra_person_commision: specialExtraCommission,
    };
    let url = `${URLS.PROPERTY_SPECIAL_PRICE}${id ? id + "/edit" : "create"}/`;
    let method = id ? put : post;
    const res = await method(url, payload);
    console.log("special date creation", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      setShowAdd(false);
      emptyFormData();
      viewPrices();
    }
  };

  const handleAddDate = () => {
    if (!startDate) {
      toast.error("Select Date");
    }
    if (startDate) {
      const formatted = startDate.toLocaleDateString("en-GB"); // "dd/mm/yyyy"
      setDates((prev) => [...prev, formatted]);
      setSelectedDate(formatted); // set active tab to new date
      setSelectedDay(moment(formatted, "DD/MM/YYYY").format("dddd"));
      setStartDate(null);
      setPopup(false);
    }
  };

  useEffect(() => {
    emptyFormData();
    viewPrices();
  }, [selectedDate]);

  const emptyFormData = () => {
    setFormData({
      id: "",
      slotType: "",
      slotTime: "",
      propPrice: "",
      vowCommission: "",
      extraPrice: "",
      extraCommission: "",
      specialPrice: "",
      specialCommission: "",
      specialExtraPrice: "",
      specialExtraCommission: "",
      day: "",
    });
  };

  const viewPrices = async () => {
    const payload = {
      property_id: property_id,
      property_room_id: room_id,
    };
    if (selectedDate) {
      payload["special_date"] = moment(selectedDate, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      payload["day"] = selectedDay;
    }
    const res = await post(`${URLS.PROPERTY_SLOT_SPECIAL_DATES}`, payload);
    // console.log("view prices", res);
    if (res?.status === "success") {
      const {
        special_dates,
        days,
        day_prices,
        created_slots,
        special_date_commission_percentage,
        special_prices,
      } = res?.data;
      setTabsData?.({ slot: days, specialDates: special_dates });
      let formatted = special_dates?.map((item) =>
        moment(item, "YYYY-MM-DD").format("DD/MM/YYYY")
      );
      let final_List = formatted;
      if (!final_List.includes(selectedDate)) {
        final_List.push(selectedDate);
      }
      setDates(final_List?.filter((item) => item));

      let available_slots_filtered = created_slots?.filter((item) => {
        let find_slot = special_prices?.find(
          (s) => s?.time_slot_id === item?.id
        );
        if (!find_slot) {
          return true;
        } else {
          return false;
        }
      });
      let available_slots = available_slots_filtered?.map((item) => {
        return { value: item?.id, label: item?.timeslot_name, ...item };
      });

      setSpecialPriceData((prev) => ({
        ...prev,
        [selectedDay]: {
          slotsList: day_prices,
          createdslots: created_slots,
          availableSlots: available_slots,
          specialPrices: special_prices ?? [],
          gst: special_date_commission_percentage,
        },
      }));
    }
  };

  const handleDateChangeInForm = (d) => {
    let dateDay = moment(d, "DD/MM/YYYY").format("dddd");
    let alreadyExists = dates?.find((item) => item === d);
    if (!alreadyExists) {
      setDates((prev) => [...prev, d]);
    }
    emptyFormData();
    setSelectedDate(d);
    setSelectedDay(dateDay);
  };

  const handleDelete = async (id) => {
    const res = await deletes(`${URLS.PROPERTY_SPECIAL_PRICE}${id}/delete/`);
    console.log("deleted", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      emptyFormData();
      viewPrices();
    }
  };

  const formatTime = (time) => {
    return time < 12
      ? time + "AM"
      : time === 12
      ? time + "PM"
      : time - 12 + "PM";
  };
  return (
    <div className="mt-4 bg-sec1 px-3 py-4 rounded-4">
      <div className="d-flex ac-jb mb-3">
        <p className="f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
          {" "}
          Special date Price (dates)
        </p>
        {!viewOnly && (
          <button
            onClick={() => {
              setPopup(true);
            }}
            className="add-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
          >
            + Add Date
          </button>
        )}
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb mb-4">
              <p className="f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {" "}
                Add Date
              </p>
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setPopup(false);
                }}
              />
            </div>
            <DatePicker
              selected={startDate}
              minDate={moment()}
              onChange={(date) => {
                console.log("testing selected ", date);
                setStartDate(date);
              }}
              dateFormat={"dd/MM/yyyy"}
              placeholderText="DD/MM/YYYY"
              excludeDates={dates.map((d) => moment(d, "DD/MM/YYYY").toDate())}
            />
            <div className="d-flex ac-je mt-5">
              <button
                onClick={handleAddDate}
                className="add-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
              >
                Add Date
              </button>
            </div>
          </div>
        </div>
      )}
      {dates.length !== 0 && (
        <div>
          <div className="d-flex ac-js mt-2">
            <div
              onClick={() => {
                if (datesScrollRef.current) {
                  datesScrollRef.current?.scrollBy({
                    left: -200,
                    behavior: "smooth",
                  });
                }
              }}
            >
              <ArrowLeftIcon style={{ fontSize: "50px" }} />
            </div>
            <div
              ref={datesScrollRef}
              className="d-flex ac-js gap-5 overflow-scroll"
              style={{ scrollBehavior: "smooth" }}
            >
              {dates.map((day, i) => {
                return (
                  <p
                    onClick={() => {
                      setSelectedDate(day);
                      setSelectedDay(moment(day, "DD/MM/YYYY").format("dddd"));
                    }}
                    className={`${
                      selectedDate === day
                        ? " prim-btn act-date-price f3"
                        : "gray2 f2"
                    }  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 pointer`}
                  >
                    {" "}
                    {day}
                  </p>
                );
              })}
            </div>
            <div
              onClick={() => {
                if (datesScrollRef.current) {
                  datesScrollRef.current?.scrollBy({
                    left: 200,
                    behavior: "smooth",
                  });
                }
              }}
            >
              <ArrowRightIcon style={{ fontSize: "50px" }} />
            </div>
          </div>
          {selectedDate && (
            <div key={selectedDate}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "1rem",
                }}
              >
                {!viewOnly && (
                  <button
                    onClick={() => {
                      setShowAdd("add");
                      emptyFormData();
                    }}
                    className="add-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
                  >
                    + Add Special Date Slot
                  </button>
                )}
              </div>
              {specialPriceData?.[selectedDay]?.specialPrices?.map(
                (item, ind) => {
                  let start = moment(item?.start_time, "HH:mm:ss");
                  let end = moment(item?.end_time, "HH:mm:ss");
                  let start_hrs = start.get("hours");
                  let end_hrs = end.get("hours");
                  let hrs = end_hrs - start_hrs;
                  let total_hrs = hrs < 0 ? hrs + 24 : hrs;
                  console.log("formated ", start_hrs, end_hrs, hrs, total_hrs);
                  let name = `${total_hrs} hrs, ${formatTime(
                    start_hrs
                  )} - ${formatTime(end_hrs)}`;
                  return (
                    <div>
                      <div className="slot-box mt-4 mb-4">
                        <div className="d-flex ac-jb">
                          <div className="col-md-7">
                            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-1">
                              Slot {ind + 1}{" "}
                              <span className="f4">({name})</span>
                            </p>
                          </div>
                          <ArrowForwardIosRoundedIcon
                            className="pointer"
                            style={{
                              rotate: item?.id === showAdd ? "90deg" : "0deg",
                            }}
                            onClick={() => {
                              if (item?.id === showAdd) setShowAdd(false);
                              else handleEdit(item);
                            }}
                          />
                        </div>
                      </div>
                      {showAdd === item?.id && (
                        <DatePrice
                          key={selectedDate + formData?.id}
                          customStyles={customStyles}
                          date={moment(selectedDate, "DD/MM/YYYY").format(
                            "YYYY-MM-DD"
                          )}
                          specialpriceData={specialPriceData?.[selectedDay]}
                          viewOnly={viewOnly}
                          formData={formData}
                          setFormData={setFormData}
                          handleSubmit={handleSubmit}
                          handleDateChangeInForm={handleDateChangeInForm}
                          handleDelete={handleDelete}
                        />
                      )}
                    </div>
                  );
                }
              )}
              {showAdd === "add" && (
                <DatePrice
                  key={selectedDate + formData?.id}
                  customStyles={customStyles}
                  date={moment(selectedDate, "DD/MM/YYYY").format("YYYY-MM-DD")}
                  specialpriceData={specialPriceData?.[selectedDay]}
                  viewOnly={viewOnly}
                  formData={formData}
                  setFormData={setFormData}
                  handleSubmit={handleSubmit}
                  handleDateChangeInForm={handleDateChangeInForm}
                  handleDelete={handleDelete}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SpecialDate;
